/**
 * NotFound — 404 for unknown in-app paths. Because the SPA runs behind the Flask
 * catch-all rewrite (decision #9), the server always serves index.html and the
 * router lands here for genuinely unknown routes.
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";
import { useSession } from "@/stores/session";

export default function NotFound() {
  const orgId = useSession((s) => s.currentOrgId);
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
      <div className="text-3xl font-semibold text-ink">Not found</div>
      <p className="text-sm text-ink-muted">That page does not exist in this scope.</p>
      <Link to={orgId ? `/o/${orgId}` : "/"}>
        <Button variant="primary">Back to health</Button>
      </Link>
    </div>
  );
}
